<div class="mat-elevation-z2">
  <mat-form-field appearance="outline" color="primary">
    <mat-label i18n>Go to page</mat-label>
    <input matInput [formControl]="formControl" tmAutoFocus (click)="select($event)" />
  </mat-form-field>
</div>
